import { InvestmentGeographyName } from 'generated/graphql';
import {
  enumCache,
  fields
} from 'modules';

import * as dataService from './dataService';



interface IProps {
  label?: string;
}

export const InvestmentGeographySelectField = (props?: IProps) => {
  return fields.genEnumSelectFieldComponent<InvestmentGeographyName, enumCache.IGenericEnum<InvestmentGeographyName>>(dataService.useInvestmentGeographySelectField, {
    label: props?.label
  });
};

export const InvestmentGeographyMultiSelectField = (props?: IProps) => {
  return fields.genEnumMultiSelectFieldComponent<InvestmentGeographyName, enumCache.IGenericEnum<InvestmentGeographyName>>(dataService.useInvestmentGeographySelectField, {
    label: props?.label
  });
};

export const InvestmentGeographyGroupedMultiSelectField = (props?: IProps) => {
  return fields.genGroupedEnumMultiSelectFieldComponent<InvestmentGeographyName, enumCache.IExtendedEnum<InvestmentGeographyName>>(dataService.useInvestmentGeographySelectField, {
    label: props?.label
  });
};
